import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const ShariPage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  return (
    <Layout location={props.location}>
      <Helmet>
        <html className="memberpage" lang="da" />
      </Helmet>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <div className="space-8"></div>

            <div className="grid">
              <div className="member-2col-left">
                <div className="member-inner">
                  <h1>Shari Paetzke</h1>
                  <h3>Professional</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Date of employment at Emento
                      </div>
                      <div class="flex-row" role="cell">
                        December 2023
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Title
                      </div>
                      <div class="flex-row" role="cell">
                        Partner Manager eHealth
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Responsibilities
                      </div>
                      <div class="flex-row" role="cell">
                        Partner Management
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Educational background
                      </div>
                      <div class="flex-row" role="cell">
                        Historical Cultural Studies
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Previous positions/industries
                      </div>
                      <div class="flex-row" role="cell">
                        Global Mobility Manager, Account Manager, Sales Manager/
                        Global Mobility, Healthcare
                      </div>
                    </div>
                  </div>
                  <h3>Personal</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Bucket list no. 1
                      </div>
                      <div class="flex-row" role="cell">
                        Caring of elephants at a sanctuary
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Favorite music
                      </div>
                      <div class="flex-row" role="cell">
                        German rap; 90s/00s
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Biggest food or drink consumption
                      </div>
                      <div class="flex-row" role="cell">
                        White rice and water
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Best TV series
                      </div>
                      <div class="flex-row" role="cell">
                        Stranger Things
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Extraordinary skill
                      </div>
                      <div class="flex-row" role="cell">
                        Empathy, open-mindness
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Preferred traveling style
                      </div>
                      <div class="flex-row" role="cell">
                        Car
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        My friends recognizes me for
                      </div>
                      <div class="flex-row" role="cell">
                        Being reliable and a joker
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        As a kid, I wanted to become
                      </div>
                      <div class="flex-row" role="cell">
                        Make-up artist or Psychotherapist
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Social links
                      </div>
                      <div class="flex-row" role="cell">
                        <Link
                          to="https://de.linkedin.com/in/shari-paetzke-gms-t%C2%AE-2b1776169"
                          target="_blank"
                          rel="noreferrer"
                        >
                          LinkedIn
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-middle">
                <div className="member-hero-inner">
                  <div className="member-hero-box">
                    <div className="member-hero-image">
                      <img
                        src="/images/portraits/internal/shari_hero.jpg"
                        alt=""
                      />
                    </div>
                    <h3>Feels like: Sailor Moon</h3>
                    Strength
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Artistic
                    <div className="full-bar">
                      <div className="bar size-50" />
                    </div>
                    Spontaneous
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Determined
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Polite
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Playful
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Empathy
                    <div className="full-bar">
                      <div className="bar size-90" />
                    </div>
                    Intelligence
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Brave
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-right">
                <div className="member-childhood-inner">
                  <div
                    className="member-childhood-image"
                    style={{
                      backgroundImage: `url(/images/portraits/internal/shari_child.jpg)`,
                    }}
                  >
                    <div className="blur-bg">
                      <img
                        src="/images/portraits/internal/shari_child.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ShariPage
